const normalizeValue = (value) => {
    if (value && typeof value === 'object' && value !== null) {
        if (typeof value.value !== 'undefined') {
            return value.value;
        }
        if (typeof value.id !== 'undefined') {
            return value.id;
        }
    }
    return value;
};

const sortValues = (a, b) => {
    const strA = String(a);
    const strB = String(b);
    return strA.localeCompare(strB, undefined, { numeric: true, sensitivity: 'base' });
};

export const sanitizeSegments = (segments) => {
    if (!segments || typeof segments !== 'object') {
        return {};
    }

    return Object.keys(segments).reduce((acc, key) => {
        if (!key) {
            return acc;
        }

        const segment = segments[key] || {};
        const exclusive = !!segment.exclusive;
        const valuesArray = Array.isArray(segment.values) ? segment.values : [];
        const normalizedValues = valuesArray
            .map(normalizeValue)
            .filter((value) => value !== undefined && value !== null && value !== '')
            .sort(sortValues);

        if (!normalizedValues.length) {
            return acc;
        }

        acc[key] = {
            exclusive,
            values: normalizedValues
        };

        return acc;
    }, {});
};

export const areSegmentsEqual = (prevSegments, nextSegments) => {
    if (prevSegments === nextSegments) {
        return true;
    }

    const prevKeys = Object.keys(prevSegments || {}).sort();
    const nextKeys = Object.keys(nextSegments || {}).sort();

    if (prevKeys.length !== nextKeys.length) {
        return false;
    }

    for (let i = 0; i < prevKeys.length; i += 1) {
        if (prevKeys[i] !== nextKeys[i]) {
            return false;
        }

        const prevSegment = prevSegments[prevKeys[i]] || {};
        const nextSegment = nextSegments[nextKeys[i]] || {};

        if (!!prevSegment.exclusive !== !!nextSegment.exclusive) {
            return false;
        }

        const prevValues = Array.isArray(prevSegment.values) ? prevSegment.values : [];
        const nextValues = Array.isArray(nextSegment.values) ? nextSegment.values : [];

        if (prevValues.length !== nextValues.length) {
            return false;
        }

        for (let j = 0; j < prevValues.length; j += 1) {
            if (String(prevValues[j]) !== String(nextValues[j])) {
                return false;
            }
        }
    }

    return true;
};

export default {
    sanitizeSegments,
    areSegmentsEqual
};
